export default __webpack_public_path__ + "static/media/ursinerush.313e448a.png";